import * as React from "react";
import { BaseSVG } from "../../BaseSVG";

export const PlayIcon = props => (
  <BaseSVG viewBox="0 0 100 100" {...props}>
    <g>
      <path
        d="M59.5 30L84 68.4 84 68.4C84.9 69.8 84.5 71.6 83.1 72.5 82.6 72.8 82.1 73 81.5 73L32.5 73 32.5 73C30.9 73 29.5 71.7 29.5 70 29.5 69.4 29.7 68.9 30 68.4L54.5 30 54.5 30C55.4 28.6 57.2 28.2 58.6 29.1 59 29.3 59.3 29.6 59.5 30Z"
        transform="translate(57.00, 50.00) rotate(90.00) translate(-57.00, -50.00)"
      />
    </g>
  </BaseSVG>
);
